import React, { useEffect, useState, useCallback } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import { useHistory } from 'react-router-dom'
import client from "../../services/Api";
import http from '../../services/Api';
import { useForm } from 'react-hook-form';

import './index.css'
import { Button } from 'react-bootstrap';
import { RiLoader4Line } from 'react-icons/ri';
import { useAuth } from '../../providers/auth';
import swal from 'sweetalert';

function AddBeacon() {
    const { register, handleSubmit } = useForm();
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [devices, setDevices] = useState([])
    const [filterData, setFilterData] = useState([]);
    const [filterText, setFilterText] = useState(null);
    const [selectedData, setSelectedData] = useState([]);
    // FORCE DATATABLE REBUILDS //
    const [tableKey, setTableKey] = useState(0);
    const history = useHistory();
    const { user } = useAuth()

    const query = new URLSearchParams(window.location.search);
    const client_id = query.get('id');
    const user_id = query.get('id');


    useEffect(() => {
        init()
        setLoading(true)
    }, []);

    useEffect(() => {
        search(filterText)
        setTableKey((key) => {
            key++;
            return key;
        });
    }, [filterText]);

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
        },
        {
            name: 'Endereço Mac',
            selector: 'mac',
            sortable: false,
        },
    ];



    const customStyles = {
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: '#03989E',
                    color: 'white',
                    transition: '.2s'
                },
            }
        },
    };

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    async function getProfile() {
        try {
            const response = await http.get(`/api/user/show/${user_id}`);
            return response.data;
        } catch (e) {
            console.log(e);
            setLoading(false)
        }
    }


    async function init() {
        setButtonLoading(true);
        let user = await getProfile();
        let availableDevices = user.available_devices;
        const enterprise = user.profile._id !== "6086f50d46258e47f28ec9d5" ? await getEnterprise() : null;
        const response = await getBeacons(enterprise);

        if (response !== null) {
            let data = response.data;
            data.map((item) => {
                item.checked = availableDevices.includes(item._id)
                return item
            });

            setDevices(data);
            setFilterData(data);
        }
        setLoading(false);
        setButtonLoading(false);
    }
    async function getEnterprise() {
        try {
            const response = await client.get(`/api/user-client-id/${user.id}`)
            const id = response.data._id;
            return id;
        } catch (e) {
            console.log(e)
        }
    }

    async function getBeacons(enterprise) {
        try {
            if (user.profile._id == "6086f50d46258e47f28ec9d5") {
                const response = await client.get("/api/beacon-device/allAdmin");
                setLoading(false);
                return response;
            } else {
                const response = await client.get(`/api/devices-by-client/${enterprise}`);
                setLoading(false);
                return response;
            }

        } catch (e) {
            console.log(e);
            setLoading(false);
        }
        return null;
    }

    const addBeacon = async () => {
        const ids = selectedData[0].map((item) => item._id);
        const url = user.profile._id == "6086f50d46258e47f28ec9d5" ? '/api/devices/link/client' : '/api/devices/link/user';
        const id = user.profile._id == "6086f50d46258e47f28ec9d5" ? client_id : user_id;
        const idIndex = user.profile._id == "6086f50d46258e47f28ec9d5" ? 'client_id' : 'user_id';

        const sendData = {
            devices: ids,
            to_update: 0
        }
        sendData[idIndex] = id;

        try {
            setButtonLoading(true);
            await http.post(url, sendData);
            setButtonLoading(false)
            const ok = await swal("Dispositivos vínculados com sucesso!",
                {
                    title: "Sucesso!",
                    buttons: {
                        login: {
                            text: "OK",
                            value: "my-devices",
                        },
                    },
                    icon: "success",
                })
            history.push('select-user')
        } catch (e) {
            console.log(e)
            setButtonLoading(false);
        }
    }

    const filterCheckeds = (e) => {
        setTableKey((key) => {
            key++;
            return key;
        });

        const { checked } = e.target;
        let data = devices
        if (checked)
            data = selectedData[0];
        setFilterData(data);
    }

    const search = (text) => {
        let filterData = devices.filter(item => item.mac && item.mac.toLowerCase().includes(text.toLowerCase()) || item.name && item.name.toLowerCase().includes(text.toLowerCase()));
        setFilterData(filterData);
    }

    /**
     * Mark checked box one time only
     */
    const initChecks = useCallback((row) => {
        return row.checked;
    }, []);

    return (
        <div className="AddBeacon sidenav-margin">
            <AresNavBar />
            <SideBar />

            <div className="content">
                <div className="container-header">
                    <h1>Vincular Dispositivos</h1>

                    <Button variant="primary" className="customBtn1" onClick={addBeacon}>
                        {buttonLoading ?
                            <RiLoader4Line className="spin" />
                            :
                            'Salvar'
                        }
                    </Button>
                </div>
                {loading ?
                    renderLoading()
                    :
                    <div>
                        {data()}
                    </div>
                }
            </div>
        </div>
    );

    function data() {
        return (
            <div className="beacon-table">
                <Form.Group>
                    <Form.Check type="checkbox" label="Filtrar selecionados" onChange={filterCheckeds} />
                </Form.Group>

                <Form style={{ marginBottom: '10px' }} onSubmit={handleSubmit(data => setFilterText(data.search))}>
                    <Form.Group >
                        <Form.Label>Buscar dispositivo</Form.Label>
                        <div className="search">
                            <Form.Control type="text" name="search" placeholder="Buscar.." ref={register} />
                            <Button variant="secondary" className="filterButton" type="submit">
                                Filtrar
                            </Button>
                        </div>
                    </Form.Group>
                </Form>

                <DataTable
                    selectableRows
                    data={filterData}
                    columns={columns}
                    onSelectedRowsChange={({ selectedRows }) => selectedData[0] = selectedRows}
                    selectableRows
                    selectableRowSelected={tableKey <= 1 ? initChecks : null}
                    contextMessage={{
                        singular: 'item',
                        plural: 'itens',
                        message: 'selecionado(s)'
                    }}
                    noDataComponent={
                        <span>Nada encontrado...</span>
                    }
                    pagination={false}
                    customStyles={customStyles}
                />
            </div>
        )
    }
}

export default AddBeacon;
